import { FC } from 'react';

import { useEditStore } from 'page/CustomerPage/hooks';
import { ConfirmationModalView } from 'page/CustomerPage/components/ConfirmationModalView';

type Props = {
  handleClose: () => void;
  handleClickGoInput: () => void;
  handleClickUpdate: () => void;
};

export const ConfirmationModal: FC<Props> = ({
  handleClose,
  handleClickGoInput,
  handleClickUpdate,
}) => {
  const {
    isOpenConfirmationModal,
    name,
    detail,
    environment,
    corporateNumber,
    channel,
    poseidonUrl,
    status,
    systemUpdateGroup,
    iapClientId,
    iapClientSecret,
    poseidonAgentCpu,
    poseidonAgentMemory,
    enableVerticalPodAutoScaler,
  } = useEditStore();

  return (
    <>
      {/* 確認モーダル */}
      <ConfirmationModalView
        mode="更新"
        isOpen={isOpenConfirmationModal}
        name={name}
        detail={detail}
        environment={environment}
        corporateNumber={corporateNumber}
        channel={channel}
        poseidonUrl={poseidonUrl}
        status={status}
        systemUpdateGroup={systemUpdateGroup}
        iapClientId={iapClientId}
        iapClientSecret={iapClientSecret}
        poseidonAgentCpu={poseidonAgentCpu}
        poseidonAgentMemory={poseidonAgentMemory}
        enableVerticalPodAutoScaler={enableVerticalPodAutoScaler}
        handleClose={handleClose}
        handleClickGoInput={handleClickGoInput}
        handleClickExecution={handleClickUpdate}
      />
    </>
  );
};
